import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../../api/instance';

/**
 * Получить количество активных запросов на присоединение к компании
 * текущего пользователя.
 *
 * Эндпоинт `/joinrequests/?company=<id>` возвращает список заявок,
 * нам в сайдбар нужен только `length` (для бейджа). Сами заявки тянет
 * отдельно карточка компании (см. Company.tsx → fetchBasicGroupInvites).
 *
 * Если у юзера нет компании или сервер вернул не-массив — считаем 0,
 * чтобы бейдж не вспыхивал из-за неподходящего scope'а.
 */
export const fetchPendingJoinRequestsCount = createAsyncThunk<number, number | null>(
  'joinRequests/fetchCount',
  async (companyId, { rejectWithValue }) => {
    if (!companyId) return 0;
    try {
      const response = await apiClient.get('/joinrequests/', {
        params: { company: companyId, count: 100 },
      });
      const data = response.data;
      if (Array.isArray(data)) return data.length;
      // На некоторых эндпоинтах LimitOffset-пагинация — `count` лежит в
      // мете. Подстраховываемся.
      if (data && typeof data === 'object' && 'count' in data) {
        const c = (data as { count: unknown }).count;
        return typeof c === 'number' ? c : 0;
      }
      return 0;
    } catch (error) {
      // Молча: 403/404 на joinrequests у юзеров без прав — это нормально,
      // бейдж просто не показываем.
      return rejectWithValue(error);
    }
  }
);
